// Same rule as the SQL function normalize_name() that /api/clusters?search= applies to names
// (api/migrations/Version20251120203721.php): accents removed, lower case, everything but a-z
// dropped — so hyphens, spaces and apostrophes never prevent a match.
export const normalizeName = (text: string): string =>
  text
    .normalize("NFD") // "é" becomes "e" + a combining accent, dropped with the rest below
    .toLowerCase()
    .replace(/[^a-z]/g, "")

// Whether a name matches a search typed by the user, as the API decides it: every word of the
// search, normalized, appears somewhere in the normalized name, in any order. Words left empty by
// the normalization (digits, punctuation) are ignored, as on the server.
export const matchesNormalizedName = (name: string, search: string): boolean => {
  const normalizedName = normalizeName(name)
  return search
    .split(/\s+/)
    .map(normalizeName)
    .filter(word => word !== "")
    .every(word => normalizedName.includes(word))
}

// react-select filterOption: keeps the options the API returned for the same search, instead of
// react-select's plain substring match, which hid "Pied-à-terre Trocadéro" for
// "Pied a terre Trocadero" (ticket #1638).
export const normalizedNameFilter = (option: { label: string }, search: string): boolean =>
  matchesNormalizedName(option.label, search)
